<template>
    <div class="suggestions">
        <ul class="divide-y">
            <li @mousedown.prevent.stop="openIframeChat"  v-if="isChatEnabled">
                <Search-entry-gpt />
                <hr/>
            </li>
            <li v-for="result in props.searchSuggestions">
                <NuxtLink role="menuitem"
                          class="flex items-center gap-[16px] text-left p-[8px] hover:bg-gray-300 hover:text-gray-700"
                          :to="`/search?q=${props.query}#${result.toLowerCase()}`"
                          :aria-label="`View results for ${result}`"
                          external>
                    <Icon class="w-[16px] h-[16px]" :icon="`${getCategoryIconClass(result)}`"/>
                    <div class="font-normal text-[14px] leading-[160%] align-middle whitespace-nowrap">
                        {{ result }}
                    </div>
                </NuxtLink>
            </li>
        </ul>
    </div>
</template>

<script setup lang="tsx">
import Icon from '~/components/ui/atom/icon.vue'
import {NuxtLink} from '#components'
import SearchEntryGpt from "~/components/ui/molecule/gpt/searchEntryGpt.vue";
import { defineEmits } from 'vue';
import { useIframeStore } from '@/stores/chatAIStore';
import { storeToRefs } from 'pinia';
import { useDynamicYieldStore } from '@/stores/dynamicYieldStore';

const nuxtApp = useNuxtApp()
const config = nuxtApp.$config
const localeStore = useLocaleStore()
const { locale } = storeToRefs(localeStore)



const dyStore = useDynamicYieldStore();

    const isMyComponentEnabled = computed(() => {
        const myVariationData = dyStore.getCustomJSONVariationBySelector(config?.public?.abTestName ?? '');
        return !!myVariationData?.data?.enabled;
    });

const isChatEnabled = computed(() =>
  config?.public?.chatIframeEnabled === 'Y' &&
  (locale.value?.country?.taiaEnabled ?? false) &&
    isMyComponentEnabled.value
);

interface SearchSuggestionCategoryProps {
    query: string
    searchSuggestions: string[]
}

const props = defineProps<SearchSuggestionCategoryProps>();
const showChatPopup = computed(() => iframeStore.showChatPopup);

const iframeStore = useIframeStore();
const { inputSearchQuery,minimiseValue} = storeToRefs(iframeStore);
const emit = defineEmits<{
      (e: 'clear-search-results'): void
    }>()
const openIframeChat = () => {
    emit('clear-search-results')
    iframeStore.openIframe()
     if(showChatPopup.value && minimiseValue.value) {
        iframeStore.handleMiniseAndMaxiseEvent(false)
    }
    if(showChatPopup.value ) {
            iframeStore.postMessageToIframe({
            type: 'send_pills',
            data: { value: inputSearchQuery.value }
        });
    }
  const screenName = document.title;  
  eventBusGtm.emit('trackEvent', {
    event: 'Taia',
    button_name: 'search',
    screen_name: screenName,
  });
};

function getCategoryIconClass(categoryName: string) {
    switch (categoryName) {
        case "Products":
            return "capsules"
        case "Articles":
            return "newspaper"
        case "Videos":
            return "video"
        case "Ingredients":
            return "mortar-pestle"
        case "Resources":
        case "Affiliates":
        case "Podcasts":
        default:
            return "book"
    }
}
</script>